export class Activity1
{
    ActivityNo: string;
    Label : string;
    Net: number;
    TVA: number;
    Percentage: number;
    Total: number;
    TVAApplicable: boolean;
}

export class Activity2
{
    ActivityNo: string;
    Label : string;
    Net: number;
    TVA: number;
    Percentage: number;
    Total: number;
    TVAApplicable: boolean;
}

export class Activity3
{
    ActivityNo: string;
    Label : string;
    Net: number;
    TVA: number;
    Percentage: number;
    Total: number;
    TVAApplicable: boolean;
}

export class Activity4
{
    ActivityNo: string;
    Label : string;
    Net: number;
    TVA: number;
    Percentage: number;
    Total: number;
    TVAApplicable: boolean;
}

export class Activity5
{
    ActivityNo: string;
    Label : string;
    Net: number;
    TVA: number;
    Percentage: number;
    Total: number;
    TVAApplicable: boolean;
}